import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Modal, Button } from '@getro/rombo';
import { trackEvent } from 'helpers/analytics';
import iconPerson from '../../../assets/icon-person.svg';

const SUPPORT_EMAIL = 'help@getro.com';

const AdminSupportModal = ({ isOpen, action, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      trackEvent('team_members:support_modal_viewed', { action });
    }
  }, [isOpen, action]);

  return (
    <Modal isOpen={isOpen} onCancel={onClose}>
      <Flex sx={{ flexDirection: 'column', alignItems: 'center', gap: '24px', textAlign: 'center', p: '16px' }}>
        <Box as="img" src={iconPerson} alt="" width="80px" height="80px" />

        <Flex sx={{ flexDirection: 'column', gap: '8px' }}>
          <Text sx={{ fontSize: '20px', fontWeight: 700, color: 'text.dark' }}>
            Our CSX team will help you manage admins
          </Text>
          <Text sx={{ fontSize: '16px' }}>
            Email us at {SUPPORT_EMAIL} and we&apos;ll help you add, remove, or update admin roles.
          </Text>
        </Flex>

        <Button
          as="a"
          href={`mailto:${SUPPORT_EMAIL}?subject=Admin management request`}
          onClick={() => {
            trackEvent('team_members:email_support_clicked', { action });
            onClose();
          }}
        >
          Email {SUPPORT_EMAIL}
        </Button>
      </Flex>
    </Modal>
  );
};

AdminSupportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  action: PropTypes.oneOf(['invite_admin', 'remove_admin', 'edit_role']),
  onClose: PropTypes.func.isRequired,
};

AdminSupportModal.defaultProps = {
  action: null,
};

export default AdminSupportModal;
